<template>
  <div class="my-pooq-content-body" data-scroll-element="true">
    <portal to="customer-search">
      <div class="cus-search-wrap">
        <div class="cus-search-top">
          <h3 class="a11y-hidden">공지사항 검색</h3>
          <div class="search-box">
            <div class="search-icon">
              <SearchIcon/>
            </div>
            <input type="text" placeholder="궁금한 점이 있다면 검색해 주세요." class="search-input"
                   ref="searchInput"
                   @focus.prevent="onFocusSearchInput"
                   @keypress.enter="enter"
                   :value="searchKeyword"
                   v-on:input="searchKeyword = $event.target.value">
            <label for=""></label>
            <button class="delate-btn" v-if="searchKeyword.length" @click.prevent="clearSearchKeyword">
              <span class="a11y-hidden">검색어 삭제</span>
              <DeleteTextIcon/>
            </button>
          </div>
          <button type="button" class="reload-btn" @click.prevent="reloadPage">
            <SearchReIcon v-if="!reSearchButtonActive"/>
            <SearchReActiveIcon v-if="reSearchButtonActive"/>
          </button>
        </div>
      </div>
      <template v-if="isMobileDevice">
        <div class="cus-filter-wrap">
          <select id="CustomerNoticeFilterList" v-model="filterText" class="cus-filter">
            <option v-for="(filterItem, index) in filterList" :key="'filter_' + index" ref="filterData" :data-filterObj="JSON.stringify(filterItem)">
              {{filterItem.title}}</option>
          </select>
        </div>
      </template>
      <div  v-else class="sorting-btn">
        <button type="button" class="sorting-btn-all" @click.prevent="toggleSelectBox">
          <SortIcon/>
          <span class="sorting-filter-hd">{{filterText}}</span>
          <span>
          <IconDown v-if="!toggleSelect"/>
          <IconUp v-if="toggleSelect"/>
        </span>
        </button>
        <ul class="sorting-list" v-if="toggleSelect">
          <li v-for="(filterItem, index) in filteredFilterList" :key="'filter_' + index">
            <button type="button" :data-src="filterItem.filterId" @click.prevent="()=>setFilter(filterItem)">
              {{filterItem.title}}
            </button>
          </li>
        </ul>
      </div>
    </portal>
    <div class="customer-wrap"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200">
      <my-pooq-empty-list v-if="showEmptyList" :info-text="getEmptyText()"></my-pooq-empty-list>
      <ul>
        <li :class="notice.istop === 'y' ? 'top-notice' : ''" v-for="(notice, index) in noticeList" :key="'notice_' + index">
          <a href="#" type="button" class="cus-list-btn" @click.prevent="()=>readNotice(notice.noticeid)">
            <span class="cus-preview">
              <span class="type">{{notice.noticetypetext}}</span>
              <span>
                <strong class="cus-title" v-html="notice.noticetitle"></strong>
                <span v-if="notice.isNew === 'y'" class="cus-tag-new">new</span>
              </span>
              <span class="cus-list-date">{{notice.regdate}}</span>
            </span>
          </a>
        </li>
      </ul>
      <div class="dimmed" v-if="dimmed"></div>
    </div>
    <div class="btn-float" @click.prevent="openKaKaoBizMsg">
      <a href="#">
        <img src="@/assets/images/btn-kakao.png" alt="카카오톡 상담하기">
        <form id="form-biz" action="https://bizmessage.kakao.com/chat/open" method="post" target="_blank">
          <input type="hidden" name="uuid" value="@pooqtv" />
          <input type="hidden" name="extra" value="mobile"/>
        </form>
      </a>
    </div>
  </div>
</template>

<script>
import SearchIcon from '@/assets/svg/common/ic-input-search.svg'
import DeleteTextIcon from '@/assets/svg/common/ic-input-delete.svg'
import SearchReIcon from '@/assets/svg/common/ic-search-re-d.svg'
import SearchReActiveIcon from '@/assets/svg/common/ic-search-re-a.svg'
import SortIcon from '@/assets/svg/common/ic-sort.svg'
import IconDown from '@/assets/svg/common/ic-down-p.svg'
import IconUp from '@/assets/svg/common/ic-up-p.svg'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import { CustomerService } from '@/common/api/api.service'
import { infiniteScroll } from '@/common/directives'
import { get, replace } from 'lodash'
import { EventBus } from '@/components/eventbus/EventBus'
import { isMobileDevice } from '@/common/util/ua'
export default {
  name: 'CustomerNotice',
  components: {
    SearchIcon,
    DeleteTextIcon,
    SearchReIcon,
    SearchReActiveIcon,
    SortIcon,
    IconDown,
    IconUp,
    MyPooqEmptyList
  },
  directives: {
    infiniteScroll
  },
  data () {
    return {
      toggleSelect: false,
      offset: 0,
      limit: 20,
      filterId: 'all',
      filterText: '전체',
      faqId: '',
      searchKeyword: '',
      endOfList: false,
      showEmptyList: false,
      dimmed: false,
      reSearchButtonActive: false,
      filterList: [
        { title: '전체', filterId: 'all' },
        { title: '서비스공지', filterId: 'service' },
        { title: '콘텐츠공지', filterId: 'contents' }
      ],
      filteredFilterList: [],
      noticeList: [],
      isLoading: false
    }
  },
  computed: {
    isMobileDevice () {
      return isMobileDevice()
    }
  },
  methods: {
    readNotice (noticeid) {
      this.$router.push(`/customer/notice_view/${noticeid}`)
    },
    reloadPage () {
      this.$router.go(0)
    },
    getEmptyText () {
      return `'${this.searchKeyword}'에 대한 공지사항이 없습니다.`
    },
    setFilterList () {
      this.filteredFilterList = this.filterList.filter((filter) => {
        return filter.filterId !== this.filterId
      })
    },
    reset () {
      this.noticeList = []
      this.offset = 0
      this.endOfList = false
      this.showEmptyList = false
      this.reSearchButtonActive = false
    },
    setFilter (filter) {
      this.reset()
      this.$nextTick(() => {
        this.filterId = filter.filterId
        this.filterText = filter.title
        this.filteredFilterList = this.filterList.filter((filterItem) => {
          return filterItem.filterId !== this.filterId
        })
        this.toggleSelectBox()
      })
      window.scrollTo(0, 0)
    },
    toggleSelectBox () {
      this.toggleSelect = !this.toggleSelect
    },
    enter () {
      this.reset()
      this.setData()
      document.querySelector('.search-input').blur()
    },
    onFocusSearchInput () {
      this.dimmed = true
      // dimmed on
    },
    clearSearchKeyword () {
      this.searchKeyword = ''
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      let service = null
      if (this.searchKeyword !== '') {
        this.reSearchButtonActive = true
        service = CustomerService.getSearchNotice({
          type: this.filterId,
          keyword: this.searchKeyword,
          offset: this.offset,
          limit: this.limit,
          orderby: 'new'
        }).then((response) => {
          response.data.list = response.data.list.map((notice) => {
            notice.noticetitle = replace(notice.noticetitle, new RegExp(this.searchKeyword, 'g'), `<span style="color:#3887ff">${this.searchKeyword}</span>`)
            return notice
          })
          return response
        })
      } else {
        service = CustomerService.getNoticeList({
          type: this.filterId,
          top: 'all',
          offset: this.offset,
          limit: this.limit,
          orderby: 'new'
        })
      }
      service.then(({ data }) => {
        let resList = get(data, 'list', [])
        this.endOfList = resList.length === 0
        this.showEmptyList = this.noticeList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.noticeList = this.noticeList.concat(resList)
        this.isLoading = false
      })
    },
    openKaKaoBizMsg () {
      document.getElementById('form-biz').submit()
    }
  },
  mounted () {
    this.setFilterList()
  },
  created () {
    let kakaoBiz = document.createElement('script')
    kakaoBiz.setAttribute('src', 'https://bizmessage.kakao.com/chat/includeScript')
    document.body.appendChild(kakaoBiz)

    if (this.$route.params.keyword) {
      this.searchKeyword = this.$route.params.keyword
      this.setData()
    }
    if (get(this.$route, ['query', 'filterType'], '') !== '') {
      this.filterId = this.$route.query.filterType
      this.filterText = this.filterId === 'all' ? '전체' : this.filterId === 'service' ? '서비스공지' : '콘텐츠공지'
      this.searchKeyword = get(this.$route, ['query', 'searchWord'], '')
    }
  },
  watch: {
    filterId () {
      this.$router.push({
        name: 'notice_list',
        query: {
          filterType: this.filterId,
          searchWord: this.searchKeyword
        }
      })
      this.setData()
    },
    toggleSelect () {
      EventBus.$emit('toggle', this.toggleSelect)
    },
    filterText () {
      const selectedOpt = this.$refs.filterData.filter(filter => filter.selected)[0].dataset.filterobj
      this.setFilter(JSON.parse(selectedOpt))
      document.getElementById('CustomerNoticeFilterList').blur()
      document.getElementById('CustomerNoticeFilterList').style.display = "none"
      setTimeout(() => {
        document.getElementById('CustomerNoticeFilterList').style.display = "inline"  
      }, 50);
    }
  }
}
</script>

<style scoped>
  .customer-wrap {
    position: relative;
    width: 100%;
    /*height: 100%;*/
    /*overflow-y: scroll;*/
    /*overflow-scrolling: touch;*/
    /*-webkit-overflow-scrolling: touch;*/
  }
  /* 카카오톡 상담하기 버튼 */
  .btn-float{
    width: 48px;
    position: fixed;
    bottom: 8px;
    right: 8px;
    z-index: 1001;
  }
  .btn-float a{
    display: block;
  }
  .btn-float img{
    max-width: 100%;
  }
  .search-box input[type=text] {
    width: 100%;
    height: 36px;
    padding-left: 10px;
    background-color: #2f2f2f;
    -webkit-border-radius: 36px;
    -moz-border-radius: 36px;
    border-radius: 36px;
    line-height: 40px;
    vertical-align: middle;
    box-sizing: border-box;
  }
  .sorting-btn-all .sorting-filter-hd{
    margin: 0 5px;
    font-size: 14px;
    color: #fff;
  }
  .cus-title{
    vertical-align: middle;
  }
  .cus-tag-new{
    display: inline-block;
    vertical-align: middle;
    width: 31px;
    height: 18px;
    padding: 2px 0;
    margin-left: 8px;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    color: #3887ff;
    border: 1px solid  #3887ff;
  }
</style>
